import React, { useState } from "react";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import toast from "react-hot-toast";
import postStripeCheckout from "../../services/stripe/postStripeCheckout";

const StripeSubscriptionButton = ({ plan_id, closeModal }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);
        try {
            const result = await postStripeCheckout(plan_id);
            if (result.checkout_url) {
                window.location.href = result.checkout_url;
            } else {
                toast.error('Error creating checkout session');
                setLoading(false);
            }
        } catch (error) {
            console.error('Stripe checkout error:', error);
            toast.error('Payment error. Please try again.');
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleClick}
            disabled={loading}
            variant="contained"
            data-testid="button-stripe-subscribe"
            sx={{
                width: '100%',
                padding: '12px 24px',
                backgroundColor: '#00a271',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '16px',
                borderRadius: '24px',
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: '#008f63',
                },
                '&:disabled': {
                    backgroundColor: '#ccc',
                }
            }}
        >
            {loading ? (
                <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
                'Subscribe Now'
            )}
        </Button>
    );
};

export default StripeSubscriptionButton;
